export const formatMoney = (value: number): string => {
  const formattedValue: string = (value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedValue;
};

export const formatDateView = (dateString: Date | string): string => {
  const date: Date = new Date(dateString);

  // Pad single digits with leading zero
  // @ts-ignore
  const pad = (num) => (num < 10 ? `0${num}` : num);

  const formattedDate: string = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;

  return formattedDate;
};

export const formatStatus = (status: string | number): string => {
  let statusString: string = '';

  if (status === 0) {
    statusString = 'Pendente';
  } else if (status === 1) {
    statusString = 'Confirmada';
  } else if (status === 2) {
    statusString = 'Desfeita';
  } else if (status === 3) {
    statusString = 'Negada';
  } else if (status === 4) {
    statusString = 'Cancelada';
  } else if (status === -1) {
    statusString = 'Cancelada posterior';
  } else if (status === -2) {
    statusString = 'Cancelada parcialmente'
  }

  return statusString;
};

export const formatAcquirer = (acquirer: any): string => {
  let acquirerStr: string = '';

  if (acquirer === 3) {
    acquirerStr = 'Adiq';
  } else if (acquirer === 10) {
    acquirerStr = 'Rede';
  } else if (acquirer === 99) {
    acquirerStr = 'Valori';
  }
  return acquirerStr;
};

export const formatChannel = (channel: string): string => {
  if (channel === 'PHYSICAL') return 'Físico';
  else if (channel === 'DIGITAL') return 'Digital';
  else return '';
}

export const clearTokens = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userInfo');
}
